// ** Angular Import
import { Component } from '@angular/core';

// ** Custom Component Import
import { SectionHeadingComponent } from '@shared/components/core/sections/section-heading/section-heading.component';

// ** Pipe Imports
import { CdnUrlPipe } from '@shared/pipes/cdn-url.pipe';


@Component({
  selector: 'app-product-menu-side-container',
  imports: [
    SectionHeadingComponent,
    CdnUrlPipe
  ],
  templateUrl: './product-menu-side-container.component.html',
  styleUrl: './product-menu-side-container.component.scss'
})

export class ProductMenuSideContainerComponent {
}